<template lang="html">
    <section class="section-header">
        <div class="header-orders rel" id="header-orders">
            <div class="header-bloc row">
                <div class="header-title col-lg-6 col-md-6 col-xs-12">
                    <h1>
                        <span :id="'orderWindowIcon'" class="roundedIcon" :class="{ orderWindowActive: order.countdown != null }">
                            <i class="far fa-calendar-alt fa-lg"></i
                        ></span>
                        <b-tooltip v-if="order.countdown != null" container="header-orders" :target="'orderWindowIcon'" :placement="'right'">
                            <div class="orderWindowInfoToolTip">
                                <span>{{ order.countdown.name }}</span>
                            </div>
                        </b-tooltip>
                        {{ $t("orders.title") }} {{ order.reference }}
                    </h1>
                </div>
                <div class="header-actions col-lg-6 col-md-6 col-xs-12">
                    <button class="btn-orders btn-print">{{ $t("orders.btnOrders.btnPrint") }}</button>
                    <button
                        v-if="hasDiamAdminRights && order.status.reference_status !== 'order_shipped'"
                        @click="deleteOrder()"
                        class="btn-orders btn-cancel"
                    >
                        {{ $t("orders.btnOrders.btnCancel") }}
                    </button>
                    <button class="btn-orders btn-archive">{{ $t("orders.btnOrders.btnArchive") }}</button>
                </div>
            </div>
            <div class="header-date">
                <div class="row">
                    <div class="orders-created col-md-6 col-xs-12">
                        {{ $t("orders.labelCreated") }} {{ order.createdAt }} {{ $t("orders.labelCreatedBy") }} {{ fullNameFormat(order.createdBy) }}
                    </div>
                    <div class="orders-update col-md-6 col-xs-12">
                        {{ $t("orders.labelLastUpdate") }} {{ order.modifiedDate }} {{ $t("orders.labelLastUpdateBy") }}
                        {{ fullNameFormat(order.modifiedBy) }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex';
import {BTooltip} from "bootstrap-vue";
import connectionBO from "../../../services/connectionBO";

export default {
    name: 'orders-header',
    props: [],
    components: {'b-tooltip':BTooltip},
    data() {
        return {
            currentUser: connectionBO.getUsersData()
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions("order", {
            deleteOrderAction: 'details/deleteOrderAction'
        }),
        fullNameFormat(objName) {
            return (objName) ? objName.firstname + " " + objName.lastname : ''
        },
        async deleteOrder() {
            const result = await this.$swal({
                title: this.$t("basket.warning"),
                text: this.$t("orders.deleteOrder.textCancelOrder"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "red",
                confirmButtonText: this.$t("actions.remove"),
                cancelButtonText: this.$t("actions.cancel"),
            }).catch(() => false);
            if(result) {
                try {
                    const res = await this.deleteOrderAction();
                    this.dialogSuccess(this.$t("orders.deleteOrder.confirmDelete"));}
                catch (e) {
                    this.dialogError(e);
                }
            }

        }
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder"
        }),
        hasDiamAdminRights() {
            return this.hasDiamAccess('orders_manager', ...this.AccessUser.ADMIN) || this.currentUser.user.id === this.order.createdBy.id;
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

.header {
    &-orders {
        @extend %primary-text;
        padding: 5px;
    }
    &-bloc {
        margin-bottom: 15px;
    }
    &-date {
        & .orders-created {
            font-size: 12px;
            @media only screen and (max-width: 767px) {
                margin-bottom: 5px;
            }
        }
        & .orders-update {
            font-size: 12px;
        }
    }
    &-title {
        h1 {
            font-size: 25px;
            font-family: "oswald-regular", sans-serif;
            font-weight: bold;
            margin: 0;
            text-transform: uppercase;
            .roundedIcon {
                background-color: #a8a8a8;
                opacity: 0.4;
                &.orderWindowActive {
                    background-color: $color4;
                    opacity: 1;
                }
            }
        }

        @media only screen and (max-width: 767px) {
            margin-bottom: 10px;
        }
        @media only screen and (max-width: 992px) {
            margin-bottom: 10px;
        }
    }
    &-actions {
        text-align: right;
        @media only screen and (max-width: 767px) {
            text-align: left;
        }
        & .btn {
            &-orders {
                margin-left: 10px;
                @media only screen and (max-width: 767px) {
                    margin-left: initial;
                    margin-bottom: 10px;
                }
                @media only screen and (max-width: 992px) {
                    margin-left: initial;
                }
            }
            &-print {
                @media only screen and (max-width: 767px) {
                    display: none;
                }
                @media only screen and (max-width: 992px) {
                    display: none;
                }
            }
        }
    }
}

.orderWindowInfoToolTip {
    display: inline-block;
    background-color: $color4;
    color: #ffffff;
    padding: 6px;
    span {
        text-transform: inherit;
        display: block;
        font-size: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// order-header.vue?34a19f2c